import { render } from "./UserList.vue?vue&type=template&id=5515e5f0&scoped=true&ts=true"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"

import "./UserList.vue?vue&type=style&index=0&id=5515e5f0&scoped=true&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/QLTS/QLTS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5515e5f0"]])

export default __exports__